import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { deleteCoupon, getCouponById } from "../../api/couponService";
import { getErrorMessage } from "../../utils/errorHandler";
import FullPageLoader from "../../common/FullPageLoader";
import RecordActions from "../Shared/RecordActions";

export default function ViewCoupon() {
  const location = useLocation();
  const id = location?.state?.couponId;
  const navigate = useNavigate();

  const [coupon, setCoupon] = useState(null);
  const [loading, setLoading] = useState(true);

  //FIXED DATE FORMAT (DD/MM/YYYY)
  const formatDate = (dateStr) => {
    if (!dateStr) return "-";

    const date = new Date(dateStr);

    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();

    return `${dd}/${mm}/${yyyy}`;
  };

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const res = await getCouponById(id);
        setCoupon(res?.data || res);
      } catch (err) {
        setCoupon(null);
      } finally {
        setLoading(false);
      }
    };

    if (id) load();
    else setLoading(false);
  }, [id]);

  if (loading) return <FullPageLoader text="Loading coupon..." />;
  if (!coupon) return <div className="container-fluid p-4"><h5>Coupon not found</h5></div>;

  const handleDelete = async () => {
    if (!coupon?._id || !window.confirm("Are you sure you want to delete this coupon?")) return;

    try {
      await deleteCoupon(coupon._id);
      alert("Coupon deleted successfully");
      navigate("/coupon");
    } catch (error) {
      alert(getErrorMessage(error));
    }
  };

  return (
    <div className="container-fluid p-4">
      <div className="card p-3">
        <RecordActions
          onBack={() => navigate("/coupon")}
          onEdit={() =>
            navigate(`/coupon/edit/${coupon.code}`, {
              state: { couponId: coupon._id },
            })
          }
          onDelete={handleDelete}
        />

        <div className="row g-3">
          {/* TITLE FIRST */}
          <div className="col-md-4">
            <span className="fw-bold">Title : </span>
            {coupon.title || "N/A"}
          </div>

          {/* CODE SECOND */}
          <div className="col-md-4">
            <span className="fw-bold">Coupon Code : </span>
            {coupon.code || "N/A"}
          </div>

          <div className="col-md-4">
            <span className="fw-bold">Discount Type : </span>
            {coupon.discountType || "N/A"}
          </div>

          <div className="col-md-4">
            <span className="fw-bold">Discount Value : </span>
            {coupon.discountValue || 0}
          </div>

          <div className="col-md-4">
            <span className="fw-bold">Min Order : </span>₹
            {coupon.minOrderAmount || 0}
          </div>
          <div className="col-md-4">
            <span className="fw-bold">Max Order : </span>₹
            {coupon.minOrderAmount || 0}
          </div>

          <div className="col-md-4">
            <span className="fw-bold">Max Discount : </span>₹
            {coupon.maxDiscount || 0}
          </div>

          {/* FIXED DATE FORMAT HERE */}
          <div className="col-md-4">
            <span className="fw-bold">Expiry Date : </span>
            {formatDate(coupon.expiryDate)}
          </div>

           <div className="col-md-4">
            <span className="fw-bold"> Start Date : </span>
            {formatDate(coupon.expiryDate)}
          </div>

           <div className="col-md-4">
            <span className="fw-bold">Applicable Product: </span>
            {coupon.usageLimit || 0}
          </div>

            <div className="col-md-4">
            <span className="fw-bold">Applicable Category: </span>
            {coupon.usageLimit || 0}
          </div>

            <div className="col-md-4">
            <span className="fw-bold">Total User Usage Limit: </span>
            {coupon.usageLimit || 0}
          </div>


          <div className="col-md-4">
            <span className="fw-bold">Usage Limit : </span>
            {coupon.usageLimit || 0}
          </div>

          <div className="col-md-4">
            <span className="fw-bold">Status : </span>
            <span
              className={`badge ${
                coupon.status === "ACTIVE" ? "bg-success" : "bg-danger"
              }`}
            >
              {coupon.status || "Inactive"}
            </span>
          </div>

          <div className="col-md-12">
            <span className="fw-bold">Description : </span>
            {coupon.description || "N/A"}
          </div>
        </div>
      </div>
    </div>
  );
}
